/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { Ptw100BadGatewayException } from './Ptw100BadGatewayException';
import {
    Ptw100BadGatewayExceptionFromJSON,
    Ptw100BadGatewayExceptionFromJSONTyped,
    Ptw100BadGatewayExceptionToJSON,
} from './Ptw100BadGatewayException';

/**
 * 
 * @export
 * @interface ErrorResponseOfPtw100BadGatewayException
 */
export interface ErrorResponseOfPtw100BadGatewayException {
    /**
     * This code is used in the ExceptionMiddleware and will be set as the HTTP response status code
     * @type {number}
     * @memberof ErrorResponseOfPtw100BadGatewayException
     */
    readonly httpStatusCode?: number;
    /**
     * 
     * @type {Ptw100BadGatewayException}
     * @memberof ErrorResponseOfPtw100BadGatewayException
     */
    exception: Ptw100BadGatewayException;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseOfPtw100BadGatewayException
     */
    $type?: ErrorResponseOfPtw100BadGatewayExceptionTypeEnum;
}


/**
 * @export
 */
export const ErrorResponseOfPtw100BadGatewayExceptionTypeEnum = {
    PtwPtw100WebSharedModelsErrorResponseErrorResponse1PtwPtw100AppZeroCoreSharedExceptionsPtw100BadGatewayExceptionPtwPtw100AppZeroCoreSharedPtwPtw100WebShared: 'Ptw.Ptw100.Web.Shared.Models.ErrorResponse.ErrorResponse`1[[Ptw.Ptw100.AppZero.Core.Shared.Exceptions.Ptw100BadGatewayException, Ptw.Ptw100.AppZero.Core.Shared]], Ptw.Ptw100.Web.Shared'
} as const;
export type ErrorResponseOfPtw100BadGatewayExceptionTypeEnum = typeof ErrorResponseOfPtw100BadGatewayExceptionTypeEnum[keyof typeof ErrorResponseOfPtw100BadGatewayExceptionTypeEnum];



/**
 * Check if a given object implements the ErrorResponseOfPtw100BadGatewayException interface.
 */
export function instanceOfErrorResponseOfPtw100BadGatewayException(value?: unknown): value is ErrorResponseOfPtw100BadGatewayException {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ErrorResponseOfPtw100BadGatewayExceptionTypeEnum)[0];
}

export function ErrorResponseOfPtw100BadGatewayExceptionFromJSON(json: any): ErrorResponseOfPtw100BadGatewayException {
    return ErrorResponseOfPtw100BadGatewayExceptionFromJSONTyped(json, false);
}

export function ErrorResponseOfPtw100BadGatewayExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorResponseOfPtw100BadGatewayException {
    if (json == null) {
        return json;
    }
    return {
        
        'httpStatusCode': json['httpStatusCode'] == null ? undefined : json['httpStatusCode'],
        'exception': Ptw100BadGatewayExceptionFromJSON(json['exception']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ErrorResponseOfPtw100BadGatewayExceptionToJSON(value?: Omit<ErrorResponseOfPtw100BadGatewayException, 'httpStatusCode'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'exception': Ptw100BadGatewayExceptionToJSON(value['exception']),
        '$type': value['$type'],
    });
}

